import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useT } from "../features/UseT";
import "./CompanyDetailsScreen.css";

function CompanyDetailsScreen() {
  const t = useT();
  const lang = useSelector((s) => s.language.current);
  const [ppHtml, setPpHtml] = useState({});
  useEffect(() => {
    if (!lang) return;
    fetch(`/longtxt/companydetails.json`)
      .then((res) => res.json())
      .then((data) => setPpHtml(data))
      .catch(console.error);
  }, [lang]);
  return (
    <div className="CompanyDetailsScreen">
      <a href="/" className="Back">
        <span>{`<< ${t.sdb}`}</span>
      </a>
      <span className="CompanyTitle">{ppHtml.title_en}</span>
      <span
        className="CompanyDetails"
        dangerouslySetInnerHTML={{ __html: ppHtml.en }}
      />
    </div>
  );
}

export default CompanyDetailsScreen;
